var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardEmpty2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "101px",
    height: "80px",
    viewBox: "0 0 101 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 78.96,
    height: 57.7655577,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-17.1%",
    y: "-23.4%",
    width: "141.8%",
    height: "157.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 3.34872798,
    width: 78.96,
    height: 57.7655577,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-25.1%",
    width: "144.3%",
    height: "160.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    in: "shadowInner",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "shadowInner",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-5",
    cx: 3.74021053,
    cy: 3.76731898,
    rx: 3.74021053,
    ry: 3.76731898
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-60.2%",
    y: "-59.7%",
    width: "300.5%",
    height: "299.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.11372549   0 0 0 0 0.862745098   0 0 0 0 0.752941176  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Journey-0---Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.5--Dashboard---empty-state",
    transform: "translate(-461.000000, -357.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(469.000000, 242.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Popup",
    transform: "translate(0.000000, 3.348728)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "browser"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#979797",
    strokeWidth: 1,
    strokeLinejoin: "square",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    x: 0.5,
    y: 0.5,
    width: 77.96,
    height: 56.7655577,
    rx: 4
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#DFE4EE",
    x: 0,
    y: 0,
    width: 78.96,
    height: 5.62651536
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#979797",
    x: 0.5,
    y: 0.5,
    width: 77.96,
    height: 56.7655577,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "redo",
    transform: "translate(7.821509, 2.625707)",
    fill: "#969696",
    fillRule: "nonzero",
    stroke: "#979797",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.4153243,0.675261689 C1.37418626,0.675261689 1.34083729,0.708847532 1.34083729,0.750277769 C1.34266674,1.04011897 1.139762,1.29038948 0.857413496,1.34655127 C0.575064991,1.40271306 0.292918608,1.24892382 0.185195208,0.980145923 C0.0774718073,0.711368029 0.174558398,0.403419331 0.416505569,0.246453206 C0.65845274,0.0894870813 0.977011154,0.127781104 1.17547611,0.33768933 L0.996707264,0.33768933 C0.95556922,0.33768933 0.922220246,0.371275173 0.922220246,0.412705409 C0.922220246,0.454135646 0.95556922,0.487721489 0.996707264,0.487721489 L1.33413345,0.487721489 C1.3752715,0.487721489 1.40862047,0.454135646 1.40862047,0.412705409 L1.40862047,0.0751330504 C1.40862047,0.0337028136 1.3752715,0.000116970655 1.33413345,0.000116970655 C1.29299541,0.000116970655 1.25964644,0.0337028136 1.25964644,0.0751330504 L1.25964644,0.207911512 C1.00392084,-0.0382810729 0.611526889,-0.0693595523 0.320731561,0.133547352 C0.0299362331,0.336454256 -0.079027861,0.71736301 0.060003769,1.0449806 C0.199035399,1.37259819 0.547702885,1.55653247 0.894290554,1.48509603 C1.24087822,1.41365958 1.48975994,1.10656226 1.48981132,0.750277769 C1.48981132,0.730382267 1.4819636,0.711301634 1.46799458,0.69723339 C1.45402555,0.683165146 1.43507949,0.675261689 1.4153243,0.675261689 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 10.8011321,
    y: 2.62570717,
    width: 63.689434,
    height: 1.87550512,
    rx: 0.937752561
  }), /*#__PURE__*/React.createElement("g", {
    id: "list-ul",
    transform: "translate(75.235472, 3.000808)",
    fill: "#969696",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.191092068,0.964928682 C0.180465698,0.956391489 0.16793523,0.949699349 0.154219667,0.94523626 C0.127016622,0.935857227 0.096504454,0.935857227 0.0693014091,0.94523626 C0.0555858459,0.949699349 0.0430553779,0.956391489 0.0324290077,0.964928682 C0.022256624,0.973846884 0.0142826898,0.984363104 0.00896475226,0.995873917 C-0.00853251285,1.03079487 0.000724936825,1.07112141 0.0324290077,1.09808696 C0.0432897111,1.10637006 0.0557608696,1.11303052 0.0693014091,1.11777939 C0.0963456261,1.12781097 0.12717545,1.12781097 0.154219667,1.11777939 C0.167760206,1.11303052 0.180231365,1.10637006 0.191092068,1.09808696 C0.222796139,1.07112141 0.232053589,1.03079487 0.214556324,0.995873917 C0.209238386,0.984363104 0.201264452,0.973846884 0.191092068,0.964928682 Z M0.558698737,0.187546877 L2.12298243,0.187546877 C2.18469172,0.187546877 2.23471698,0.145563079 2.23471698,0.0937734385 C2.23471698,0.0419837985 2.18469172,0 2.12298243,0 L0.558698737,0 C0.496989449,0 0.446964187,0.0419837985 0.446964187,0.0937734385 C0.446964187,0.145563079 0.496989449,0.187546877 0.558698737,0.187546877 Z M0.191092068,0.49606149 C0.158961603,0.469453786 0.110911031,0.461684454 0.0693014091,0.476369068 C0.0557608696,0.48111793 0.0432897111,0.487778394 0.0324290077,0.49606149 C0.022256624,0.504979692 0.0142826898,0.515495911 0.00896475226,0.527006724 C-0.00298825075,0.549703636 -0.00298825075,0.575577626 0.00896475226,0.598274538 C0.0146231986,0.609638462 0.0225593904,0.620104906 0.0324290077,0.629219772 C0.0432897111,0.637502868 0.0557608696,0.644163332 0.0693014091,0.648912194 C0.0963456261,0.658943775 0.12717545,0.658943775 0.154219667,0.648912194 C0.167760206,0.644163332 0.180231365,0.637502868 0.191092068,0.629219772 C0.200961686,0.620104906 0.208897877,0.609638462 0.214556324,0.598274538 C0.226509327,0.575577626 0.226509327,0.549703636 0.214556324,0.527006724 C0.209238386,0.515495911 0.201264452,0.504979692 0.191092068,0.49606149 Z M2.12298243,0.468867192 L0.558698737,0.468867192 C0.496989449,0.468867192 0.446964187,0.510850991 0.446964187,0.562640631 C0.446964187,0.614430271 0.496989449,0.656414069 0.558698737,0.656414069 L2.12298243,0.656414069 C2.18469172,0.656414069 2.23471698,0.614430271 2.23471698,0.562640631 C2.23471698,0.510850991 2.18469172,0.468867192 2.12298243,0.468867192 Z M0.191092068,0.0271942972 C0.180465698,0.0186571043 0.16793523,0.0119649645 0.154219667,0.00750187508 C0.112610045,-0.00718273876 0.064559473,0.000586593917 0.0324290077,0.0271942972 C0.0225593904,0.0363091636 0.0146231986,0.0467756077 0.00896475226,0.0581395319 C-0.00298825075,0.0808364437 -0.00298825075,0.106710433 0.00896475226,0.129407345 C0.0146231986,0.140771269 0.0225593904,0.151237713 0.0324290077,0.16035258 C0.0432897111,0.168635675 0.0557608696,0.17529614 0.0693014091,0.180045002 C0.110911031,0.194729616 0.158961603,0.186960283 0.191092068,0.16035258 C0.200961686,0.151237713 0.208897877,0.140771269 0.214556324,0.129407345 C0.226509327,0.106710433 0.226509327,0.0808364437 0.214556324,0.0581395319 C0.208897877,0.0467756077 0.200961686,0.0363091636 0.191092068,0.0271942972 Z M2.12298243,0.937734385 L0.558698737,0.937734385 C0.496989449,0.937734385 0.446964187,0.979718183 0.446964187,1.03150782 C0.446964187,1.08329746 0.496989449,1.12528126 0.558698737,1.12528126 L2.12298243,1.12528126 C2.18469172,1.12528126 2.23471698,1.08329746 2.23471698,1.03150782 C2.23471698,0.979718183 2.18469172,0.937734385 2.12298243,0.937734385 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrow-right",
    transform: "translate(1.117358, 2.625707)",
    fill: "#969696",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.20544625,0.702623288 C5.1998036,0.687287908 5.19134278,0.673277583 5.18054928,0.661396232 L4.58776436,0.0367438637 C4.55769137,0.00505417851 4.51385902,-0.00732205235 4.47277855,0.00427717745 C4.43169807,0.0158764072 4.39961057,0.0496888988 4.38860309,0.0929778137 C4.37759561,0.136266729 4.38934045,0.182455451 4.41941344,0.214145136 L4.81065149,0.625166394 L3.91080398,0.625166394 C3.84532677,0.625166394 3.792247,0.681099673 3.792247,0.750096868 C3.792247,0.819094063 3.84532677,0.875027341 3.91080398,0.875027341 L4.81065149,0.875027341 L4.41941344,1.2860486 C4.39696911,1.30950637 4.38434449,1.34143808 4.38434449,1.37474924 C4.38434449,1.40806039 4.39696911,1.4399921 4.41941344,1.46344987 C4.44167449,1.48710079 4.47197716,1.5004041 4.5035889,1.5004041 C4.53520064,1.5004041 4.56550332,1.48710079 4.58776436,1.46344987 L5.18054928,0.838797504 C5.19134278,0.826916153 5.1998036,0.812905828 5.20544625,0.797570448 C5.21730408,0.767154705 5.21730408,0.73303903 5.20544625,0.702623288 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.41319925,0.702623288 C1.4075566,0.687287908 1.39909578,0.673277583 1.38830228,0.661396232 L0.795517362,0.0367438637 C0.765444367,0.00505417851 0.721612022,-0.00732205235 0.680531547,0.00427717745 C0.639451072,0.0158764072 0.607363569,0.0496888988 0.596356089,0.0929778137 C0.585348609,0.136266729 0.59709345,0.182455451 0.627166445,0.214145136 L1.01840449,0.625166394 L0.118556984,0.625166394 C0.0530797697,0.625166394 0,0.681099673 0,0.750096868 C0,0.819094063 0.0530797697,0.875027341 0.118556984,0.875027341 L1.01840449,0.875027341 L0.627166445,1.2860486 C0.604722108,1.30950637 0.592097488,1.34143808 0.592097488,1.37474924 C0.592097488,1.40806039 0.604722108,1.4399921 0.627166445,1.46344987 C0.649427487,1.48710079 0.679730161,1.5004041 0.711341904,1.5004041 C0.742953646,1.5004041 0.77325632,1.48710079 0.795517362,1.46344987 L1.38830228,0.838797504 C1.39909578,0.826916153 1.4075566,0.812905828 1.41319925,0.797570448 C1.42505708,0.767154705 1.42505708,0.73303903 1.41319925,0.702623288 Z",
    id: "Path",
    transform: "translate(0.711046, 0.750202) scale(-1, 1) translate(-0.711046, -0.750202) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1.489811, 0.750202)",
    fill: "#969696"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 0.528480367,
    cy: 0.562651536,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 2.79339623,
    cy: 0.562651536,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 5.05831209,
    cy: 0.562651536,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,5.62651536 L78.96,5.62651536",
    id: "Path-2",
    stroke: "#969696"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#7450C8",
    x: 2.60716981,
    y: 45.0121229,
    width: 20.1124528,
    height: 9.75262663,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 7.07660377,
    y: 46.512527,
    width: 11.1735849,
    height: 1.12530307
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 9.31132075,
    y: 51.7639413,
    width: 6.70415094,
    height: 1.87550512
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 4.84188679,
    y: 48.7631331,
    width: 15.6430189,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 4.84188679,
    y: 50.2635372,
    width: 15.6430189,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#1DDCC0",
    strokeWidth: 2,
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "check-circle",
    transform: "translate(75.635368, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#1DDCC0",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.75754779,2.55800959 L3.15299747,4.17795675 L2.53586274,3.55634912 C2.44445578,3.44883882 2.30093323,3.40200886 2.16430313,3.43511298 C2.02767302,3.46821709 1.92099519,3.5756681 1.88812929,3.71328848 C1.85526338,3.85090886 1.90175636,3.99547163 2.00849305,4.0875411 L2.88744253,4.97662838 C2.95802734,5.04714751 3.05358156,5.08645957 3.15299747,5.08588063 C3.25111811,5.08546448 3.34514681,5.0462274 3.41481221,4.97662838 L5.28491747,3.09296888 C5.35572439,3.02223122 5.39555227,2.9259401 5.39555227,2.82548924 C5.39555227,2.72503837 5.35572439,2.62874726 5.28491747,2.55800959 C5.13903525,2.41194174 4.90343001,2.41194174 4.75754779,2.55800959 Z",
    id: "Path",
    fill: "#FFFFFF"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardEmpty2);
export default __webpack_public_path__ + "static/media/dashboard-empty-2.6224f96a1900bd79fca03be7fc5683ee.svg";
export { ForwardRef as ReactComponent };